export function getIndiaNow() {
  const now = new Date();
  const indiaString = now.toLocaleString("en-US", {
    timeZone: "Asia/Kolkata",
  });
  return new Date(indiaString);
}

export function getIndiaTimeParts() {
  const now = getIndiaNow();
  return {
    hours: now.getHours(),
    minutes: now.getMinutes(),
    totalMinutes: now.getHours() * 60 + now.getMinutes(),
  };
}

export function isWorkerVisibleWindow() {
  const { totalMinutes } = getIndiaTimeParts();
  const start = 5 * 60 + 30; // 5:30 AM
  const end = 18 * 60 + 30; // 6:30 PM
  return totalMinutes >= start && totalMinutes <= end;
}

export function canAssignNewJobs() {
  const { totalMinutes } = getIndiaTimeParts();
  return totalMinutes < 18 * 60; // before 6:00 PM
}

export function shouldForceOffline({ acceptedJobs = [] }) {
  const { totalMinutes } = getIndiaTimeParts();

  const afterSixPm = totalMinutes >= 18 * 60;
  if (!afterSixPm) return false;

  const hasActiveJob = acceptedJobs.some((job) =>
    ["accepted", "in_progress"].includes(job.status)
  );

  return !hasActiveJob;
}

export function getEffectiveWorkerStatus(rawStatus, acceptedJobs = []) {
  if (!isWorkerVisibleWindow()) return "offline";

  if (shouldForceOffline({ acceptedJobs })) return "offline";

  return rawStatus || "offline";
}